<span class="override-tag" [class.override-tag--green]="badgeClass === 'override-tag--green'" [class.override-tag--red]="badgeClass === 'override-tag--red'">{{ label }}</span>
